function renderBuildDefaultValueFromSyncFunctionsGeneratedValueTemplate({
  currentValueName,
  targetName,
  canSyncExpression,
  previousValueExpression,
  nextValueExpression
}: {
  currentValueName: string
  targetName: string
  canSyncExpression: string
  previousValueExpression: string
  nextValueExpression: string
}): string {
  return `    const ${currentValueName} = form.getValues('${targetName}') as unknown
    if (${canSyncExpression}(
      ${currentValueName} === '' ||
      ${currentValueName} === undefined ||
      ${currentValueName} === null ||
      ${currentValueName} === ${previousValueExpression}
    )) {
      form.setValue('${targetName}', ${nextValueExpression} as never, {
        shouldDirty: false,
        shouldValidate: true
      })
    }`
}

function renderBuildDefaultValueFromSyncFunctionsPreviousValueTemplate({
  defaultValueFromHandlerName,
  sourceName,
  targetSync
}: {
  defaultValueFromHandlerName: string
  sourceName: string
  targetSync: string
}): string {
  return `  function ${defaultValueFromHandlerName}(nextValue: unknown) {
    const previousValue = form.getValues('${sourceName}') as unknown
${targetSync}
  }`
}

export function renderBuildDefaultValueFromSyncFunctionsRenderer(
  request:
    | {
        kind: 'renderBuildDefaultValueFromSyncFunctionsGeneratedValueTemplate'
        props: {
          currentValueName: string
          targetName: string
          canSyncExpression: string
          previousValueExpression: string
          nextValueExpression: string
        }
      }
    | {
        kind: 'renderBuildDefaultValueFromSyncFunctionsPreviousValueTemplate'
        props: {
          defaultValueFromHandlerName: string
          sourceName: string
          targetSync: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildDefaultValueFromSyncFunctionsGeneratedValueTemplate':
      return renderBuildDefaultValueFromSyncFunctionsGeneratedValueTemplate(request.props)
    case 'renderBuildDefaultValueFromSyncFunctionsPreviousValueTemplate':
      return renderBuildDefaultValueFromSyncFunctionsPreviousValueTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
